import * as React from "react";
import moment, { Moment } from "moment-timezone";
import { currentRangeUrlQueryFormat } from "../../schoolfeed/utils";

export type ICurrentRange = {
  start: string;
  end: string;
};

export const currentMonthFormat = "MMM-YYYY";
export const currentDateFormat = "D-MMM-YYYY";

export function useCleverCalendarData(
  onRangeChange: (range: ICurrentRange) => void,
  initialDate?: string,
) {
  // tracks the current calendar view - separate from currentDate because changing the month shouldn't also change the currently selected day
  const [currentMonth, setCurrentMonth] = React.useState<string>(
    initialDate
      ? moment(initialDate, currentDateFormat).format(currentMonthFormat)
      : moment().format(currentMonthFormat),
  );
  // tracks the currently selected day
  const [currentDate, setCurrentDate] = React.useState<Moment>(
    initialDate ? moment(initialDate, currentDateFormat) : moment(),
  );

  const prevMonth = React.useCallback(() => {
    setCurrentMonth((v) => {
      const newMoment = moment(v, currentMonthFormat).subtract(1, "months");
      onRangeChange({
        start: moment(newMoment)
          .startOf("month")
          .format(currentRangeUrlQueryFormat),
        end: moment(newMoment)
          .add(1, "months")
          .startOf("month")
          .format(currentRangeUrlQueryFormat),
      });
      return newMoment.format(currentMonthFormat);
    });
  }, []);

  const nextMonth = React.useCallback(() => {
    setCurrentMonth((v) => {
      const newMoment = moment(v, currentMonthFormat).add(1, "months");
      onRangeChange({
        start: moment(newMoment)
          .startOf("month")
          .format(currentRangeUrlQueryFormat),
        end: moment(newMoment)
          .add(1, "months")
          .startOf("month")
          .format(currentRangeUrlQueryFormat),
      });
      return newMoment.format(currentMonthFormat);
    });
  }, []);

  return {
    currentMonth,
    currentDate,
    nextMonth,
    prevMonth,
    setCurrentDate,
    setCurrentMonth,
  };
}
